import { createCrudService } from "@dgs/core";
import { TagIndexResource, TagOptionResource, TagSaveRequest, TagUpdateResource } from "../types";

const baseKey = ["tags"];
const quickFilterKey = [...baseKey, "quick-filter"];

export const tagService = {
	...createCrudService<TagIndexResource, TagOptionResource, TagUpdateResource, TagSaveRequest>(baseKey),
	quickFilterKey,
};
